module.exports = {
	"articleTitle1": "The Michigan Daily's guide to Restaurant Week ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Black Pearl",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/arts/04laith-al-saadi-profile09",
	"articleSnippet1": "Jan 12, 2016 ... However, while The Earle and Logan keep their dishes the same, Black Pearl \ndoes alter its portion sizes to make up for the cost difference.",
	"articleSnippet2": "Apr 8, 2015 ... From Mondays at The Arena Sportsbar from 10:30 p.m. to 2:00 a.m. to playing \nsolo acoustic Tuesdays at the Black Pearl from 8:00 to 11:00, ...",
	"foodRecommendations": [
		{
			"text": "Seafood restuarant, morphs into cocktail lounge after 9",
			"person": "Ian McKenzie"
		}
	],
	"articleTitle2": "Artist Profile: Laith al-Saadi keeps it 'Real'",
	"address": "302 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2794,
		"lng": -83.7489
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/blackpearl.json
// module id = 829
// module chunks = 0